import AIMetadata from './AIMetadata';

export default class AMetadata implements AIMetadata {
  key: string;

  keyName: string;

  value: string;

  constructor(key: string, keyName: string, value: string) {
    this.key = key;
    this.keyName = keyName;
    this.value = value;
  }

  public static createFromKeyAndValue(key: string, value: string) {
    const keyName = AMetadata.keyNameFromKey(key);
    const metadata = new AMetadata(key, keyName, value);
    return metadata;
  }

  private static keyNameFromKey(key: string) {
    switch (key) {
      case 'Author': return '作者';
      case 'Title': return 'タイトル';
      case 'Tag': return 'タグ';
      case 'Description': return '説明';
      case 'OriginUrl': return 'URL';
      case 'CertificateUrl': return '証明書URL';
      case 'Filename': return 'ファイル名';
      default: return key;
    }
  }
}
